import { CheckCircle, Clock, PauseCircle, RefreshCw, XCircle } from 'lucide-react'

export const getStatusText = (status: string) => {
  switch (status) {
    case 'completed':
      return 'Tamamlandı'
    case 'in_progress':
      return 'Giriş Yapıldı'
    case 'pending':
      return 'Bekliyor'
    case 'abandoned':
      return 'Yarıda Bırakıldı'
    case 'expired':
      return 'Erişim Bitti'
    case 'timeout':
      return 'Zaman Doldu'
    case 'camera_access_error':
      return 'Kamera Erişim Hatası'
    case 'chunk_upload_error':
      return 'Video Yükleme Hatası'
    case 'speed_test_fail':
      return 'Hız Testi Başarısız'
    default:
      return status
  }
}

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'completed':
      return <CheckCircle className="h-5 w-5 text-green-500" />
    case 'in_progress':
      return <Clock className="h-5 w-5 text-orange-500" />
    case 'pending':
      return <Clock className="h-5 w-5 text-yellow-500" />
    case 'abandoned':
      return <PauseCircle className="h-5 w-5 text-orange-500" />
    case 'expired':
      return <XCircle className="h-5 w-5 text-red-500" />
    case 'timeout':
      return <XCircle className="h-5 w-5 text-red-500" />
    case 'camera_access_error':
      return <XCircle className="h-5 w-5 text-red-500" />
    case 'chunk_upload_error':
      return <XCircle className="h-5 w-5 text-red-500" />
    case 'renewed':
      return <RefreshCw className="h-4 w-4 text-gray-600" />
    case 'speed_test_fail':
      return <XCircle className="h-5 w-5 text-red-500" />
    default:
      return <XCircle className="h-5 w-5 text-red-500" />
  }
}

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'completed':
      return 'text-green-600'
    case 'in_progress':
      return 'text-orange-600'
    case 'pending':
      return 'text-yellow-600'
    case 'abandoned':
      return 'text-orange-600'
    case 'expired':
      return 'text-red-600'
    case 'timeout':
      return 'text-red-600'
    case 'camera_access_error':
      return 'text-red-600'
    case 'chunk_upload_error':
      return 'text-red-600'
    case 'renewed':
      return 'text-gray-600'
    case 'speed_test_fail':
      return 'text-red-600'
    default:
      return 'text-gray-500'
  }
}

export const statusFilterOptions = [
  { value: 'all', label: 'Durumlar' },
  { value: 'pending', label: getStatusText('pending') },
  { value: 'completed', label: getStatusText('completed') },
  { value: 'in_progress', label: getStatusText('in_progress') },
  { value: 'abandoned', label: getStatusText('abandoned') },
  { value: 'expired', label: getStatusText('expired') },
  { value: 'timeout', label: getStatusText('timeout') },
  { value: 'camera_access_error', label: getStatusText('camera_access_error') },
  { value: 'chunk_upload_error', label: getStatusText('chunk_upload_error') },
  { value: 'speed_test_fail', label: getStatusText('speed_test_fail') },
  { value: 'renewed', label: getStatusText('renewed') },
]

export function getEmailStatusIcon(status?: string) {
  if (status === 'sent') return <CheckCircle className="h-4 w-4 text-green-600" />
  if (status === 'deferred') return <PauseCircle className="h-4 w-4 text-yellow-500" />
  if (status === 'failed') return <XCircle className="h-4 w-4 text-red-600" />
  if (status === 'queued') return <Clock className="h-4 w-4 text-blue-400" />
  return <Clock className="h-4 w-4 text-gray-400" />
}

export function getEmailStatusColor(status?: string) {
  if (status === 'sent') return 'text-green-700'
  if (status === 'deferred') return 'text-yellow-600'
  if (status === 'failed') return 'text-red-600'
  if (status === 'queued') return 'text-blue-500'
  return 'text-gray-500'
}

export function getEmailStatusText(status?: string) {
  if (status === 'sent') return 'Gönderildi'
  if (status === 'failed') return 'Gönderilemedi: Hata'
  return 'Gönderilmedi'
}

export const emailStatusFilterOptions = [
  { value: 'all', label: 'Email Statüleri' },
  { value: 'sent', label: getEmailStatusText('sent') },
  { value: 'failed', label: getEmailStatusText('failed') },
  { value: 'not_sent', label: 'Gönderilmedi' },
]
